<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {Model} from "@/app/Model";
import Chart from 'chart.js/auto';
import Choices from "choices.js";
import {Comms, type IEsito} from "@/app/Comms";
import * as bootstrap from 'bootstrap';
import MinMaxSlider from '@/components/atomics/MinMaxSliderDashboard.vue';
import PaginazioneDashboard from "@/components/atomics/PaginazioneDashboardPenale.vue";
import PaginazioneDashboardJump from "@/components/atomics/PaginazioneDashboardPenaleJump.vue";
import type {KeyValoreStr, KeyValoreStrNum, KeyValoreStrNumArr} from "@/app/data/DataTypes";
import {PdfGenerator} from "@/app/PdfGenerator";

declare let frontendConfig: any;
declare let gtagO: Function;

let model: Model = Model.getReactiveInstance();
let filtersHtml = ref("");
let chart1: Chart | null = null;
let chart2: Chart | null = null;
let chart3: Chart | null = null;
let chart4: Chart | null = null;
let chart5: Chart | null = null;
let chart6: Chart | null = null;
let choices: Choices | null = null;
let choice2: Choices | null = null;
let choice3: Choices | null = null;
let choice4: Choices | null = null;
let choice5: Choices | null = null;
const CHART_COLORS = {
  gfl1: 'rgb(67,172,239)',
  gfl2: 'rgb(22, 91, 170)',
  gfl3: 'rgb(150,216,246)',
  gfl4: 'rgb(19, 51, 113)',
  gfl5: 'rgb(227, 242, 253)',
  gfl6: 'rgb(41, 98, 255)',
  gfl7: 'rgb(161, 85, 185)',
  gfl8: 'rgb(22, 191, 214)'
};

// START ----------------------
onMounted(() => {
  checkStart();
});
function checkStart(): void {
  if (!Model.pen_setupped) {
    setTimeout(() => checkStart(), 100)
  } else if (!Comms.listAllDone) {
    Comms.getInstance().listAll(() => {
      checkStart();
    });
  } else {
    initComponents();
  }
}

// MAIN ----------------------
function changeDashboardAt(field: string = ""): void {
  let valueField = "";
  let stringField = field;

  switch (field) {
    case "capo_imputazione_legge":
      valueField = model.pen_flow_dashboard.capo_imputazione_legge;
      stringField = "capo imputazione";

      if (valueField) {
        let inputCapoImputazioneLegge: HTMLElement | null = document.getElementById("input_capo_imputazione_legge");
        let optionCapoImputazioneLegge: HTMLElement | null = null;

        if (inputCapoImputazioneLegge) {
          optionCapoImputazioneLegge = inputCapoImputazioneLegge.querySelector("option");

          if (optionCapoImputazioneLegge) {
            valueField = optionCapoImputazioneLegge.innerHTML;
            valueField = valueField.replace(/&lt;small&gt;/g, "").replace(/&lt;\/small&gt;/g, "");
          }
        }
      }

      break;
    case "importo_evaso":
      valueField = model.pen_flow_dashboard.importo_evaso_da + " - " + model.pen_flow_dashboard.importo_evaso_a;
      stringField = "importo evaso";

      break;
    case "assoluzione":
      valueField = model.pen_flow_dashboard.assoluzione;
      stringField = "esito del giudizio";

      if (valueField) {
        let inputAssoluzione: HTMLElement | null = document.getElementById("input_assoluzione");
        let optionAssoluzione = null;

        if (inputAssoluzione) {
          optionAssoluzione = inputAssoluzione.querySelectorAll("option");

          if (optionAssoluzione) {
            for (let i = 0; i < optionAssoluzione.length; i++) {
              if (optionAssoluzione[i].selected == true) {
                valueField = optionAssoluzione[i].innerHTML;
              }
            }
          }
        }
      }

      break;
    case "assoluzione_motivo":
      valueField = model.pen_flow_dashboard.assoluzione_motivo;
      stringField = "motivo assoluzione";

      break;
    case "pena_principale":
      valueField = model.pen_flow_dashboard.pena_principale;
      stringField = "pena principale";

      break;
    case "importo_risarcimento":
      valueField = model.pen_flow_dashboard.importo_risarcimento_da + " - " + model.pen_flow_dashboard.importo_risarcimento_a;
      stringField = "importo risarcimento";
      
      break;
    case "id_localita":
      valueField = model.pen_flow_dashboard.id_localita;
      stringField = "città";

      if (valueField) {
        let inputLocalita: HTMLElement | null = document.getElementById("input_id_localita");
        let optionLocalita = null;

        if (inputLocalita) {
          optionLocalita = inputLocalita.querySelectorAll("option");

          if (optionLocalita) {
            for (let i = 0; i < optionLocalita.length; i++) {
              if (optionLocalita[i].selected == true) {
                valueField = optionLocalita[i].innerHTML;
              }
            }
          }
        }
      }

      break;
    case "durata_del_processo":
      valueField = model.pen_flow_dashboard.durata_del_processo + "";
      stringField = "durata processo";

      break;
    case "non_menzione_nel_casellario":
      valueField = model.pen_flow_dashboard.non_menzione_nel_casellario + "";
      stringField = "non menzione casellario";

      if (valueField == "true") {
        valueField = "sì"
      } else {
        valueField = ""
      }

      break;
    case "giudice":
      valueField = model.pen_flow_dashboard.giudice;
      break;
    case "data_pronuncia_sentenza":
      valueField = model.pen_flow_dashboard.data_pronuncia_sentenza_da + " - " + model.pen_flow_dashboard.data_pronuncia_sentenza_a;
      stringField = "anno";

      break;
    case "durata_pena":
      valueField = model.pen_flow_dashboard.durata_pena + "";
      stringField = "durata della pena";

      break;
  }

  if (valueField) {
    gtagO({
      event: 'filtro',
      filtro: stringField,
      valore: valueField,
      percorso: 'Penale'
    })
  }

  callQuery();
}
function clearAllFilters(): void {
  model.pen_flow_dashboard.reset();
  //updateMinMaxSliders(true);
  changeDashboardAt();
}
function clearSingleFilter(field: string): void {
  let canUpdate: boolean = true;
  switch (field) {
    case "":
      canUpdate = false;
      break;
    case "durata_del_processo_notNull":
      model.pen_flow_dashboard.durata_del_processo_notNull = false;
      break;
    case "durata_pena_notNull":
      model.pen_flow_dashboard.durata_pena_notNull = false;
      break;
    case "non_menzione_nel_casellario":
      model.pen_flow_dashboard.non_menzione_nel_casellario = false;
      break;
    case "durata_del_processo_active":
      model.pen_flow_dashboard.durata_del_processo_active = false;
      model.pen_flow_dashboard.durata_del_processo = 0;
      break;
    case "durata_pena_active":
      model.pen_flow_dashboard.durata_pena_active = false;
      model.pen_flow_dashboard.durata_pena = 0;
      break;
    case "importo_evaso_active":
      model.pen_flow_dashboard.importo_evaso_active = false;
      //model.pen_flow_dashboard.importo_evaso_min = Model.lista_importi_minMax[0];
      //model.pen_flow_dashboard.importo_evaso_max = Model.lista_importi_minMax[1];
      model.pen_flow_dashboard.importo_evaso_da = model.pen_flow_dashboard.importo_evaso_min; //Model.lista_importi_minMax[0];
      model.pen_flow_dashboard.importo_evaso_a = model.pen_flow_dashboard.importo_evaso_max; //Model.lista_importi_minMax[1];
      break;
    case "importo_risarcimento_active":
      model.pen_flow_dashboard.importo_risarcimento_active = false;
      //model.pen_flow_dashboard.importo_risarcimento_min = Model.lista_importi_minMax[0];
      //model.pen_flow_dashboard.importo_risarcimento_max = Model.lista_importi_minMax[1];
      model.pen_flow_dashboard.importo_risarcimento_da = model.pen_flow_dashboard.importo_risarcimento_min; //Model.lista_importi_minMax[0];
      model.pen_flow_dashboard.importo_risarcimento_a = model.pen_flow_dashboard.importo_risarcimento_max; //Model.lista_importi_minMax[1];
      break;
    case "data_pronuncia_sentenza_active":
      model.pen_flow_dashboard.data_pronuncia_sentenza_active = false;
      //model.pen_flow_dashboard.data_pronuncia_sentenza_min = Model.lista_anno_minMax[0];
      // model.pen_flow_dashboard.data_pronuncia_sentenza_max = Model.lista_anno_minMax[1];
      model.pen_flow_dashboard.data_pronuncia_sentenza_da = model.pen_flow_dashboard.data_pronuncia_sentenza_min; //Model.lista_anno_minMax[0];
      model.pen_flow_dashboard.data_pronuncia_sentenza_a = model.pen_flow_dashboard.data_pronuncia_sentenza_max; //Model.lista_anno_minMax[1];
      break;
    default:
      //@ts-ignore
      model.pen_flow_dashboard[field] = "";
      break;
  }
  if (canUpdate) changeDashboardAt();
}
//@ts-ignore
window.clearSingleFilter = clearSingleFilter;
function callQueryPaginazione(): void {
  callQuery(true);
}
function callQuery(soloPaginazione: boolean = false): void {
  //chiama i dati attuali
  Comms.getInstance().queryDashboard((e: IEsito) => {
    updateComponents();
  }, soloPaginazione);
}

// COMPONENTS INIT ----------------------
function initComponents(): void {
  //SIDEBAR
  model.sidebarCollapsed = false;
  //CHOICES
  initChoices();
  //TOOLTIPS
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  //LOAD DATA
  callQuery();
}
function initChoices(): void {
  createChoices();
  createChoice2();
  createChoice3();
  createChoice4();
  createChoice5();
}
function createChoices(): void {
  if (choices) choices.destroy();
  let choiceItems: any[] = [{
    value: "",
    label: "Tutti...",
    selected: model.pen_flow_dashboard.capo_imputazione_legge != "" ? false : true,
    disabled: false
  }];
  let dataSourceCapoImputazione = model.lista_capo_imputazione_legge;
  if (model.pen_get_dashboard.totale_capo_imputazione_legge && model.pen_get_dashboard.totale_capo_imputazione_legge.length > 0) dataSourceCapoImputazione = model.pen_get_dashboard.totale_capo_imputazione_legge;

  dataSourceCapoImputazione.forEach(x => choiceItems.push(
      {
        value: x.capo_imputazione_legge,
        label: x.capo_imputazione_legge + ((x.rubrica && x.rubrica != "" && x.rubrica !== x.capo_imputazione_legge)? " | "+ x.rubrica:"")  + (x.tot? " <small>["+x.tot+"]</small>":""),
        selected: false,
        disabled: false
      }
  ));
  let defaultItem: any = {
    value: "",
    label: "Tutti...",
    selected: true,
    disabled: false
  }
  if (model.pen_flow_dashboard.capo_imputazione_legge != "") {
    defaultItem.value = model.pen_flow_dashboard.capo_imputazione_legge;
    let useLabel: string = model.pen_flow_dashboard.capo_imputazione_legge;
    let useFind: KeyValoreStr | undefined = dataSourceCapoImputazione.find((x: KeyValoreStr): boolean => { return x.capo_imputazione_legge == model.pen_flow_dashboard.capo_imputazione_legge });
    if (useFind) useLabel = useFind.capo_imputazione_legge + ((useFind.rubrica && useFind.rubrica != "" && useFind.rubrica !== useFind.capo_imputazione_legge)? " | "+ useFind.rubrica:""),
    defaultItem.label = useLabel;
  }
  let itemItems: any[] = [defaultItem]
  //@ts-ignore
  choices = new Choices(document.getElementById('input_capo_imputazione_legge'), {
    items: itemItems,
    choices: choiceItems,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
    shouldSort: false
  });
}
function createChoice2(): void {
  if (choice2) choice2.destroy();
  let choiceItems: any[] = [{
    value: "",
    label: "Tutti...",
    selected: model.pen_flow_dashboard.id_localita != "" ? false : true,
    disabled: false
  }];
  let dataSourceCitta = model.pen_lista_citta;
  if (model.pen_get_dashboard.totale_citta && model.pen_get_dashboard.totale_citta.length > 0) dataSourceCitta = model.pen_get_dashboard.totale_citta;
  dataSourceCitta.forEach(x => choiceItems.push(
      {
        value: x.id_localita,
        label: x.citta,
        selected: false,
        disabled: false
      }
  ));
  let defaultItem: any = {
    value: "",
    label: "Tutti...",
    selected: true,
    disabled: false
  }
  if (model.pen_flow_dashboard.id_localita != "") {
    defaultItem.value = model.pen_flow_dashboard.id_localita;
    let useLabel: string = model.pen_flow_dashboard.id_localita;
    let findCitta: KeyValoreStr | undefined = dataSourceCitta.find( (x: KeyValoreStr): boolean => { return x.id_localita == model.pen_flow_dashboard.id_localita });
    if (findCitta) useLabel = findCitta.citta;
    defaultItem.label = useLabel;
  }
  let itemItems: any[] = [defaultItem]
  //@ts-ignore
  choice2 = new Choices(document.getElementById('input_id_localita'), {
    items: itemItems,
    choices: choiceItems,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
  });
}
function createChoice3(): void {
  if (choice3) choice3.destroy();
  let choiceItems: any[] = [{
    value: "",
    label: "Tutti...",
    selected: model.pen_flow_dashboard.giudice != "" ? false : true,
    disabled: false
  }];

  let dataSourceGiudici = model.pen_lista_giudici;
  if (model.pen_get_dashboard.totale_giudici && model.pen_get_dashboard.totale_giudici.length > 0) dataSourceGiudici = model.pen_get_dashboard.totale_giudici;
  dataSourceGiudici.forEach(x => choiceItems.push(
      {
        value: x.giudice,
        label: x.giudice,
        selected: false,
        disabled: false
      }
  ));
  let defaultItem: any = {
    value: "",
    label: "Tutti...",
    selected: true,
    disabled: false
  }
  if (model.pen_flow_dashboard.giudice != "") {
    defaultItem.value = model.pen_flow_dashboard.giudice;
    let useLabel: string = model.pen_flow_dashboard.giudice;
    defaultItem.label = useLabel;
  }
  let itemItems: any[] = [defaultItem]
  //@ts-ignore
  choice3 = new Choices(document.getElementById('input_giudice'), {
    items: itemItems,
    choices: choiceItems,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
  });
}
function createChoice4(): void {
  if (choice4) choice4.destroy();
  let choiceItems: any[] = [{
    value: "",
    label: "Tutti...",
    selected: model.pen_flow_dashboard.assoluzione_motivo != "" ? false : true,
    disabled: false
  }];
  model.pen_get_dashboard.distribuzione_motivi_assoluzione.forEach(x => choiceItems.push(
      {
        value: x.assoluzione_motivo,
        label: x.assoluzione_motivo,
        selected: false,
        disabled: false
      }
  ));
  let defaultItem: any = {
    value: "",
    label: "Tutti...",
    selected: true,
    disabled: false
  }
  if (model.pen_flow_dashboard.assoluzione_motivo != "") {
    defaultItem.value = model.pen_flow_dashboard.assoluzione_motivo;
    let useLabel: string = model.pen_flow_dashboard.assoluzione_motivo;
    defaultItem.label = useLabel;
  }
  let itemItems: any[] = [defaultItem]
  //@ts-ignore
  choice4 = new Choices(document.getElementById('input_assoluzione_motivo'), {
    items: itemItems,
    choices: choiceItems,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
  });
}
function createChoice5(): void {
  if (choice5) choice5.destroy();
  let choiceItems: any[] = [{
    value: "",
    label: "Tutti...",
    selected: model.pen_flow_dashboard.pena_principale != "" ? false : true,
    disabled: false
  }];
  model.pen_get_dashboard.distribuzione_delle_sanzioni.forEach(x => choiceItems.push(
      {
        value: x.pena_principale,
        label: x.pena_principale,
        selected: false,
        disabled: false
      }
  ));
  let defaultItem: any = {
    value: "",
    label: "Tutti...",
    selected: true,
    disabled: false
  }
  if (model.pen_flow_dashboard.pena_principale != "") {
    defaultItem.value = model.pen_flow_dashboard.pena_principale;
    let useLabel: string = model.pen_flow_dashboard.pena_principale;
    defaultItem.label = useLabel;
  }
  let itemItems: any[] = [defaultItem]
  //@ts-ignore
  choice5 = new Choices(document.getElementById('input_pena_principale'), {
    items: itemItems,
    choices: choiceItems,
    allowHTML: true,
    placeholder: false,
    loadingText: 'Caricamento...',
    noResultsText: 'Nessun risultato',
    noChoicesText: 'Nessun elemento da selezionare',
    itemSelectText: 'Premi per selezionare',
  });
}

// COMPONENTS UPDATE ----------------------
function updateComponents(): void {
  //console.log("Update components", model.pen_flow_dashboard, model.pen_get_dashboard)
  //CHARTS
  updateCharts();
  //FILTRI
  updateFilters();
  //CHOICES 1
  updateChoices();
  //MINMAX
  updateMinMaxSliders(true);
  //MAP
  updateMap();
  //PAGINAZIONE
  updatePaginazione();
}
let chart1exists: boolean = false;
let chart2exists: boolean = false;
let chart3exists: boolean = false;
let chart4exists: boolean = false;
let chart5exists: boolean = false;
let chart6exists: boolean = false;

function updateCharts(): void {
  //CHARTS 1 2 3
  if (Chart.getChart("canvas_assoluzione")) {
    Chart.getChart("canvas_assoluzione")?.destroy();
  }

  if (model.pen_get_dashboard.esito_del_processo.length > 0) {
    const config1 = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Esito del giudizio',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };
    model.pen_get_dashboard.esito_del_processo.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      config1.data.labels.push(Model.lista_esito_del_processo_labels[Model.lista_esito_del_processo.indexOf(x.assoluzione)] + " (" + x.percentuale + "%)");
      //@ts-ignore
      config1.data.datasets[0].data.push(x.percentuale);
    });

    let canvas1: HTMLElement | null = document.getElementById('canvas_assoluzione');
    //@ts-ignore
    chart1 = new Chart(canvas1, config1);

    if (!chart1exists) {
        chart1exists = true;
      //@ts-ignore
      canvas1.onclick = (evt: Event) => {
        //@ts-ignore
        const res = chart1.getElementsAtEventForMode(
            evt,
            'nearest',
            {intersect: true},
            true
        );
        if (res.length === 0) {
          return;
        }
        //@ts-ignore
        clickOnChart("assoluzione", chart1.data.labels[res[0].index])
      };
    }
  }

  if (Chart.getChart("canvas_distribuzione_motivi_assoluzione")) {
    Chart.getChart("canvas_distribuzione_motivi_assoluzione")?.destroy();
  }

  if (model.pen_get_dashboard.distribuzione_motivi_assoluzione && model.pen_get_dashboard.distribuzione_motivi_assoluzione.length > 0) {
    const config2 = {
      type: 'pie',
      data: {
        labels: [],
        datasets: [{
          label: 'Distribuzione motivi assoluzione',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };
    model.pen_get_dashboard.distribuzione_motivi_assoluzione.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      config2.data.labels.push(x.assoluzione_motivo + " (" + x.percentuale + "%)");
      //@ts-ignore
      config2.data.datasets[0].data.push(x.percentuale);
    });

    let canvas2: HTMLElement | null = document.getElementById('canvas_distribuzione_motivi_assoluzione');
    //@ts-ignore
    chart2 = new Chart(canvas2, config2);

    if (!chart2exists) {
      chart2exists = true;
      //@ts-ignore
      canvas2.onclick = (evt: Event) => {
        //@ts-ignore
        const res = chart2.getElementsAtEventForMode(
            evt,
            'nearest',
            {intersect: true},
            true
        );
        if (res.length === 0) {
          return;
        }
        //@ts-ignore
        clickOnChart("assoluzione_motivo", chart2.data.labels[res[0].index])
      };
    }
  }

  if (Chart.getChart("canvas_distribuzione_delle_sanzioni")) {
    Chart.getChart("canvas_distribuzione_delle_sanzioni")?.destroy();
  }

  if (model.pen_get_dashboard.distribuzione_delle_sanzioni && model.pen_get_dashboard.distribuzione_delle_sanzioni.length > 0) {
    const config3 = {
      type: 'pie',
      data: {
        labels: [],
        datasets: [{
          label: 'Distribuzione delle sanzioni',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };
    model.pen_get_dashboard.distribuzione_delle_sanzioni.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      config3.data.labels.push(x.pena_principale + " (" + x.percentuale + "%)");
      //@ts-ignore
      config3.data.datasets[0].data.push(x.percentuale);
    });

    let canvas3: HTMLElement | null = document.getElementById('canvas_distribuzione_delle_sanzioni');
    //@ts-ignore
    chart3 = new Chart(canvas3, config3);

    if (!chart3exists) {
      chart3exists = true;
      //@ts-ignore
      canvas3.onclick = (evt: Event) => {
        //@ts-ignore
        const res = chart3.getElementsAtEventForMode(
            evt,
            'nearest',
            {intersect: true},
            true
        );
        if (res.length === 0) {
          return;
        }
        //@ts-ignore
        clickOnChart("pena_principale", chart3.data.labels[res[0].index])
      };
    }
  }

  //CHARTS 4 5 6
  if (Chart.getChart("canvas_esito_del_processo_per_anno")) {
    Chart.getChart("canvas_esito_del_processo_per_anno")?.destroy();
  }

  if (model.pen_get_dashboard.esito_del_processo_per_anno && model.pen_get_dashboard.esito_del_processo_per_anno.length > 0) {
    const config4 = {
      type: "bar",
      data: {
        labels: [],
        datasets: [
          {
            label: Model.lista_esito_del_processo_labels[0],
            backgroundColor: CHART_COLORS.gfl1,
            data: [],
          }, {
            label: Model.lista_esito_del_processo_labels[1],
            backgroundColor: CHART_COLORS.gfl2,
            data: [],
          }, {
            label: Model.lista_esito_del_processo_labels[2],
            backgroundColor: CHART_COLORS.gfl3,
            data: [],
          }
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            onClick: null
          }
        },
        barRoundness: 1,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true
          }
        }
      }
    }
    model.pen_get_dashboard.esito_del_processo_per_anno.forEach((x: KeyValoreStrNumArr) => {
      //@ts-ignore
      config4.data.labels.push(x.anno);
      let assoluzione: string[] = (x.assoluzione as string[])
      for (let assIndx: number = 0; assIndx < assoluzione.length; assIndx++) {
        let l: string = assoluzione[assIndx];
        let v: number = (x.totale_sentenze as number[])[assIndx];
        //@ts-ignore
        let indx: number = Model.lista_esito_del_processo.indexOf(l);
        //@ts-ignore
        config4.data.datasets[indx].data.push(v);
      };

    });

    let canvas4: HTMLElement | null = document.getElementById('canvas_esito_del_processo_per_anno');
    //@ts-ignore
    chart4 = new Chart(canvas4, config4);

    if (!chart4exists) {
      chart4exists = true;
      //@ts-ignore
      canvas4.onclick = (evt: Event) => {
        //@ts-ignore
        const res = chart4.getElementsAtEventForMode(
            evt,
            'nearest',
            {intersect: true},
            true
        );
        if (res.length === 0) {
          return;
        }
        //@ts-ignore
        clickOnChart("data_pronuncia_sentenza", chart4.data.labels[res[0].index])
      };
    }
  }

  if (Chart.getChart("canvas_durata_del_processo_per_singola_citta")) {
    Chart.getChart("canvas_durata_del_processo_per_singola_citta")?.destroy();
  }

  if (model.pen_get_dashboard.durata_del_processo_per_singola_citta && model.pen_get_dashboard.durata_del_processo_per_singola_citta.length > 0) {
    const config5 = {
      type: "bar",
      data: {
        labels: [],
        datasets: [
          {
            label: "Durata",
            backgroundColor: Object.values(CHART_COLORS), //CHART_COLORS.gfl1,
            data: [],
          }
        ],
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            onClick: null
          }
        },
        barRoundness: 1,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true
          }
        }
      }
    }
    model.pen_get_dashboard.durata_del_processo_per_singola_citta.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      config5.data.labels.push(x.descr_provincia);
      //@ts-ignore
      config5.data.datasets[0].data.push(x.durata_del_processo);
    });

    let canvas5: HTMLElement | null = document.getElementById('canvas_durata_del_processo_per_singola_citta');
    //@ts-ignore
    chart5 = new Chart(canvas5, config5);

    if (!chart5exists) {
      chart5exists = true;
      //@ts-ignore
      canvas5.onclick = (evt: Event) => {
        //@ts-ignore
        const res = chart5.getElementsAtEventForMode(
            evt,
            'nearest',
            {intersect: true},
            true
        );
        if (res.length === 0) {
          return;
        }
        //@ts-ignore
        clickOnChart("id_localita", chart5.data.labels[res[0].index])
      };
    }
  }

  if (Chart.getChart("canvas_esito_del_processo_per_citta")) {
    Chart.getChart("canvas_esito_del_processo_per_citta")?.destroy();
  }

  if (model.pen_get_dashboard.esito_del_processo_per_citta && model.pen_get_dashboard.esito_del_processo_per_citta.length > 0) {
    const config6 = {
      type: "bar",
      data: {
        labels: [],
        datasets: [
          {
            label: Model.lista_esito_del_processo_labels[0],
            backgroundColor: CHART_COLORS.gfl1,
            data: [],
          }, {
            label: Model.lista_esito_del_processo_labels[1],
            backgroundColor: CHART_COLORS.gfl2,
            data: [],
          }, {
            label: Model.lista_esito_del_processo_labels[2],
            backgroundColor: CHART_COLORS.gfl3,
            data: [],
          }
        ],
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            onClick: null
          }
        },
        barRoundness: 1,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true
          }
        }
      }
    }
    model.pen_get_dashboard.esito_del_processo_per_citta.forEach((x: KeyValoreStrNumArr) => {
      //@ts-ignore
      config6.data.labels.push(x.descr_provincia);
      let assoluzione: string[] = (x.assoluzione as string[])
      for (let assIndx: number = 0; assIndx < assoluzione.length; assIndx++) {
        let l: string = assoluzione[assIndx];
        let v: number = (x.percentuale as number[])[assIndx];
        //@ts-ignore
        let indx: number = Model.lista_esito_del_processo.indexOf(l);
        //@ts-ignore
        config6.data.datasets[indx].data.push(v);
      };
    });

    let canvas6: HTMLElement | null = document.getElementById('canvas_esito_del_processo_per_citta');
    //@ts-ignore
    chart6 = new Chart(canvas6, config6);

    if (!chart6exists) {
      chart6exists = true;
      //@ts-ignore
      canvas6.onclick = (evt: Event) => {
        //@ts-ignore
        const res = chart6.getElementsAtEventForMode(
            evt,
            'nearest',
            {intersect: true},
            true
        );
        if (res.length === 0) {
          return;
        }
        //@ts-ignore
        clickOnChart("id_localita", chart6.data.labels[res[0].index])
      };
    }
  }
}
function updateFilters(): void {
  filtersHtml.value = "";
  if (model.pen_flow_dashboard.capo_imputazione_legge != "") {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Capo di imputazione" onclick="window.clearSingleFilter('capo_imputazione_legge')">${model.pen_flow_dashboard.capo_imputazione_legge} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.importo_evaso_active) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Importo evaso" onclick="window.clearSingleFilter('importo_evaso_active')">${model.pen_flow_dashboard.importo_evaso_da} - ${model.pen_flow_dashboard.importo_evaso_a} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.assoluzione != "") {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Esito del giudizio" onclick="window.clearSingleFilter('assoluzione')">${Model.lista_esito_del_processo_labels[Model.lista_esito_del_processo.indexOf(model.pen_flow_dashboard.assoluzione)]} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.assoluzione_motivo != "") {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Assoluzione motivo" onclick="window.clearSingleFilter('assoluzione_motivo')">${model.pen_flow_dashboard.assoluzione_motivo} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.pena_principale != "") {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Pena principale" onclick="window.clearSingleFilter('pena_principale')">${model.pen_flow_dashboard.pena_principale} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.id_localita != "") {
    let nomeCitta: string = model.pen_flow_dashboard.id_localita;
    let findCitta: KeyValoreStr | undefined = model.pen_lista_citta.find((x: KeyValoreStr): boolean => { return x.id_localita == model.pen_flow_dashboard.id_localita });
    if (findCitta) nomeCitta = findCitta.citta;
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Città" onclick="window.clearSingleFilter('id_localita')">${nomeCitta} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.giudice != "") {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Giudice" onclick="window.clearSingleFilter('giudice')">${model.pen_flow_dashboard.giudice} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.data_pronuncia_sentenza_active) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Anno" onclick="window.clearSingleFilter('data_pronuncia_sentenza_active')">${model.pen_flow_dashboard.data_pronuncia_sentenza_da} - ${model.pen_flow_dashboard.data_pronuncia_sentenza_a} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.durata_del_processo_active) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Durata processo" onclick="window.clearSingleFilter('durata_del_processo_active')">${model.pen_flow_dashboard.durata_del_processo} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.durata_pena_active) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Durata condanna" onclick="window.clearSingleFilter('durata_pena_active')">${model.pen_flow_dashboard.durata_pena} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.importo_risarcimento_active) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Importo risarcimento" onclick="window.clearSingleFilter('importo_risarcimento_active')">${model.pen_flow_dashboard.importo_risarcimento_da} - ${model.pen_flow_dashboard.importo_risarcimento_a} <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.non_menzione_nel_casellario) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Non menzione nel casellario" onclick="window.clearSingleFilter('non_menzione_nel_casellario')">No Casellario <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.durata_del_processo_notNull) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Durata del processo presente" onclick="window.clearSingleFilter('durata_del_processo_notNull')">Durata processo presente <i class="bi bi-x"></i></span>`;
  }
  if (model.pen_flow_dashboard.durata_pena_notNull) {
    filtersHtml.value += `<span class="badge rounded-pill text-bg-danger badge-filtro" title="Durata pena presente" onclick="window.clearSingleFilter('durata_pena_notNull')">Durata condanna presente <i class="bi bi-x"></i></span>`;
  }
  //console.log("FILTERS", model.pen_flow_dashboard, filtersHtml.value)
}
function updateChoices(): void {
  //CHOICES 1
  createChoices();
  if (choices) choices.setChoiceByValue(model.pen_flow_dashboard.capo_imputazione_legge);
  //CHOICES 2 3 4 5
  createChoice2();
  createChoice3();
  createChoice4();
  createChoice5();
  if (choice2) choice2.setChoiceByValue(model.pen_flow_dashboard.id_localita);
  if (choice3) choice3.setChoiceByValue(model.pen_flow_dashboard.giudice);
  if (choice4) choice4.setChoiceByValue(model.pen_flow_dashboard.assoluzione_motivo);
  if (choice5) choice5.setChoiceByValue(model.pen_flow_dashboard.pena_principale);
}
window.addEventListener(
    "listAllRefresh",
    (event) => {
      updateComponents();
    }
);
// COMPONENTS CLICK ----------------------
function clickOnChart(name: string, value: any) {
  let doIt: boolean = true;
  if (value.toString().indexOf(" (") >= 0) {
    let valuespl = value.split(" (");
    value = valuespl[0];
  }
  if (name == "id_localita") {
    if (value == "Other" || value == "other" || value == "Altre" || value == "Altro" || value == "Altri" || value == "altre" || value == "altro" || value == "altri" ) {
      doIt = false;
    } else {
      let findCitta: KeyValoreStr | undefined = model.pen_lista_citta.find((x: KeyValoreStr): boolean => {return x.citta == value });
      if (findCitta) value = findCitta.id_localita;
    }
  }
  if (name == "assoluzione") {
    if (Model.lista_esito_del_processo_labels.indexOf(value) >= 0) value = Model.lista_esito_del_processo[Model.lista_esito_del_processo_labels.indexOf(value)];
  }
  //console.log("clickOnChart", name, value)
  if (name == "data_pronuncia_sentenza") {
    model.pen_flow_dashboard.data_pronuncia_sentenza_da = model.pen_flow_dashboard.data_pronuncia_sentenza_a = value;
    model.pen_flow_dashboard.data_pronuncia_sentenza_active = true;
    if (minMaxSlider_data_pronuncia_sentenza && minMaxSlider_data_pronuncia_sentenza.value) try {
      //@ts-ignore
      minMaxSlider_data_pronuncia_sentenza.value.updateMinMaxSlider(model.pen_flow_dashboard.data_pronuncia_sentenza_da, model.pen_flow_dashboard.data_pronuncia_sentenza_a)
    } catch (e) {
      //console.log("%%%%", e)
    }
  } else {
    //@ts-ignore
    if (doIt) model.pen_flow_dashboard[name] = value;
  }
  //alert("CHART CLICK\n"+ name + " = " + value + " - "+ doIt);
  if (doIt) {
    changeDashboardAt(name);
  }
}
function clickOnBox(name: string, value: any) {

  let doIt: boolean = true;
  switch(name) {
    case "durata_del_processo":
      model.pen_flow_dashboard.durata_del_processo_notNull = true;
      break;
    case "durata_condanna":
      model.pen_flow_dashboard.durata_pena_notNull = true;
      break;
    case "importo_evaso":
      model.pen_flow_dashboard.importo_evaso_da = model.pen_flow_dashboard.importo_evaso_min;
      model.pen_flow_dashboard.importo_evaso_a = model.pen_flow_dashboard.importo_evaso_max;
      model.pen_flow_dashboard.importo_evaso_active = true;
      break;
    case "importo_risarcimento":
      model.pen_flow_dashboard.importo_risarcimento_da = model.pen_flow_dashboard.importo_risarcimento_min;
      model.pen_flow_dashboard.importo_risarcimento_a = model.pen_flow_dashboard.importo_risarcimento_max;
      model.pen_flow_dashboard.importo_risarcimento_active = true;
      break;
    case "non_menzione_nel_casellario":
      model.pen_flow_dashboard.non_menzione_nel_casellario = true;
      break;
  }
  //alert("BOX CLICK\n"+ name + " = " + value + " - "+ doIt);
  if (doIt) changeDashboardAt(name);

}

// SIDEBAR ----------------------
function toggleSidebar(): void {
  model.sidebarCollapsed = !model.sidebarCollapsed;
  let colSX: HTMLElement | null = document.getElementById("colonnaSX");
  let colDX: HTMLElement | null = document.getElementById("colonnaDX");
  if (model.sidebarCollapsed) {
    if (colSX) colSX.style.display = "none";
    if (colDX) {
      colDX.classList.remove("col-md-9", "col-lg-10");
      colDX.classList.add("col-12");
    }
  } else {
    if (colSX) colSX.style.display = "block";
    if (colDX) {
      colDX.classList.remove("col-12");
      colDX.classList.add("col-md-9", "col-lg-10");
    }
  }
}

// SLIDERS IN PAGE ----------------------
function disableActive(wtf: string): void {
  if (wtf == 'durata_del_processo') model.pen_flow_dashboard.durata_del_processo_active = false;
  if (wtf == 'durata_pena') model.pen_flow_dashboard.durata_pena_active = false;
}
function manageActive(wtf: string): void {
  if (wtf == 'durata_del_processo') {
    //const durata_del_processo_active
    model.pen_flow_dashboard.durata_del_processo_active = !model.pen_flow_dashboard.durata_del_processo_active;
  }
  if (wtf == 'durata_pena') {
    model.pen_flow_dashboard.durata_pena_active = !model.pen_flow_dashboard.durata_pena_active;
  }
  changeDashboardAt(wtf);
}

// SLIDERS MINMAX + UPDATE ----------------------
const fromMinMaxSlider = (active: boolean, cid: string) => {
  //@ts-ignore
  model.pen_flow_dashboard[cid + "_active"] = active;
  changeDashboardAt(cid)
};
const minMaxSlider_importo_evaso = ref(null);
const minMaxSlider_data_pronuncia_sentenza = ref(null);
const minMaxSlider_importo_risarcimento = ref(null);
const updateMinMaxSliders = (doSet: boolean = false): void => {
  try {
    if (doSet) {
      //@ts-ignore
      minMaxSlider_importo_evaso.value.updateMinMaxSlider(model.pen_flow_dashboard.importo_evaso_da, model.pen_flow_dashboard.importo_evaso_a)
      //@ts-ignore
      minMaxSlider_data_pronuncia_sentenza.value.updateMinMaxSlider(model.pen_flow_dashboard.data_pronuncia_sentenza_da, model.pen_flow_dashboard.data_pronuncia_sentenza_a);
      //@ts-ignore
      minMaxSlider_importo_risarcimento.value.updateMinMaxSlider(model.pen_flow_dashboard.importo_risarcimento_da, model.pen_flow_dashboard.importo_risarcimento_a);
    } else {
      //@ts-ignore
      minMaxSlider_importo_evaso.value.updateMinMaxSlider()
      //@ts-ignore
      minMaxSlider_data_pronuncia_sentenza.value.updateMinMaxSlider();
      //@ts-ignore
      minMaxSlider_importo_risarcimento.value.updateMinMaxSlider();
    }
  } catch (e) {
    //console.log("%%%%", e)
  }
}

// MAP + UPDATE ----------------------
let markers: Array<any> = [];
let map: any = undefined;
//@ts-ignore
let markersClickFunction = ({domEvent, latLng}) => {
  const {target} = domEvent;
  //console.log(target.title);
  model.pen_flow_dashboard.id_localita = target.getAttribute("id_localita");
  changeDashboardAt("id_localita");
}
async function initMap() {
  //@ts-ignore
  const {Map} = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
  map = new Map(document.getElementById('map') as HTMLElement, {
    center: {lat: 42.06842343842517, lng: 13.251924413256154},
    zoom: 6,
    mapId: 'strategiaMap666'
  });
  updateMap();
}
initMap();
async function updateMap() {
  //@ts-ignore
  const {AdvancedMarkerElement} = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
  //google.maps.event.removeListener(clickFunction);
  markers.forEach((marker: any) => {
    //marker.removeListener(markersClickFunction);
    marker.setMap(null);
    marker.dispose(); //= null;
  })
  markers = [];
  model.pen_get_dashboard.totale_sentenze_per_tribunale.forEach((x: KeyValoreStrNum) => {
    const markerTag = document.createElement("div");
    markerTag.title = x.tribunale.toString();
    markerTag.className = "marker-tag";

    //eliminato il totale tra parentesi
    //markerTag.textContent = x.tribunale.toString() + " (" + x.tot.toString() + ")";
    markerTag.textContent = x.tribunale.toString();

    markerTag.setAttribute("id_localita", x.id_localita.toString());
    
    const marker = new AdvancedMarkerElement({
      map,
      position: {lat: Number(x.lat), lng: Number(x.long)},
      content: markerTag,
      title: x.tribunale.toString(),
      gmpClickable: true
    });
    marker.addListener("click", markersClickFunction);
    markers.push(marker);
  })
}

//DOCUMENTI
const paginazione_component = ref(null);
const paginazione_jump_component = ref(null);

function sintetizzaConAi(estremi: string, id_doc_master: number, docRigaIndex: number): void {
  gtagO({
    event: 'sintetizza AI',
    target: estremi
  })

  let model: Model = Model.getReactiveInstance();
  Comms.getInstance().openSintesi('penale-dashboard', docRigaIndex, {
    id_doc_master: id_doc_master,
    username: model.user.profile.userId,
    crmid: model.user.profile.crmId
  });
}
function apriDettaglio(estremi: string = "", id_doc_master: number = -1, id_databanks: number = -1, id: string =""): void {
  gtagO({
    event: 'apri dettaglio',
    target: estremi!="" ? estremi : id_doc_master,
    destinazione: model.abbonatoDejure ? 'dejure' : 'overlay'
  })

  let comms: Comms = Comms.getInstance();
  if (id_doc_master < 0) {
    if (!model.openingDejure) {
      let allIds: number[] = [];
      model.pen_get_dashboard.sentenze_paginate.forEach((item: KeyValoreStrNum) => {
        if (item.estremi) {
          allIds.push(item.id_doc_master as number)
        }
      })
      if (model.abbonatoDejure) {
        model.openingDejure = true;
        comms.callDejure(allIds, ()=> { model.openingDejure = false});
      }
    }
  } else {
    if (model.abbonatoDejure) {
      comms.openDettaglioDejure(id_doc_master, id_databanks, id);
    } else {
      comms.openDettaglioModal(id_doc_master, id_databanks, id);
    }
  }
}
const updatePaginazione = (): void => {
  try {
    //@ts-ignore
    paginazione_component.value.updatePaginazione();
    //@ts-ignore
    if (paginazione_jump_component && paginazione_jump_component.value) paginazione_jump_component.value.updatePaginazione();
  } catch (e) {
    //console.log("%%%%", e)
  }
}
//REPORT
function generaReport(): void {
  let sFiltriAttivi = "";

  if (model.pen_flow_dashboard.capo_imputazione_legge != "") {
    sFiltriAttivi = "Capo d'imputazione";
  }
  if (model.pen_flow_dashboard.importo_evaso_active) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Importo evaso";
  }
  if (model.pen_flow_dashboard.assoluzione != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Esito del giudizio";
  }
  if (model.pen_flow_dashboard.assoluzione_motivo != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Motivo assoluzione";
  }
  if (model.pen_flow_dashboard.pena_principale != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Pena principale";
  }
  if (model.pen_flow_dashboard.importo_risarcimento_active) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Importo risarcimento";
  }
  if (model.pen_flow_dashboard.id_localita != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Città";
  }
  if (model.pen_flow_dashboard.durata_del_processo > 0) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Durata processo";
  }
  if (model.pen_flow_dashboard.non_menzione_nel_casellario) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Non menzione casellario";
  }
  if (model.pen_flow_dashboard.giudice != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Giudice";
  }
  if (model.pen_flow_dashboard.data_pronuncia_sentenza_active) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Anno";
  }
  if (model.pen_flow_dashboard.durata_pena > 0) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Durata della pena";
  }

  gtagO({
    event: 'genera report',
    filtriAttivi: sFiltriAttivi
  })

  PdfGenerator.pen_generatePdfDashboard("penale");
}
</script>

<template>
  <div class="container-fluid dashboard-page">
    <div class="row">
      <!-- COLONNA SX -->
      <div id="colonnaSX" class="sidebar border border-right border-top-0 col-md-3 col-lg-2 p-0">
        <div tabindex="-1" id="sidebarMenu"
             aria-labelledby="sidebarMenuLabel">
          <div id="sidebarMenuInner" class="d-md-flex flex-column p-0 pt-lg-3 overflow-y-auto overflow-x-hidden">

            <!-- FILTRI ATTIVI -->

              <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-1 mb-1 text-body-secondary text-uppercase">
                <span>Filtri attivi</span>
                <a class="link-secondary" href="#" aria-label="" @click="clearAllFilters()"
                   title="Pulisci tutti i filtri">
                  <i class="bi bi-x-circle"></i>
                </a>
              </h6>
              <div class="px-2 filters-badges" v-html="filtersHtml"></div>


            <!-- FILTRI -->
            <hr class="my-3">

              <!-- h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-1 mb-1 text-body-secondary text-uppercase">
                <span>Filtri </span>
              </h6 -->
              <div class="itemFiltri">
                <label for="input_capo_imputazione_legge">Capo d'imputazione</label>
                <select class="form-select js-choice" id="input_capo_imputazione_legge"
                        @change="changeDashboardAt('capo_imputazione_legge')"
                        v-model="model.pen_flow_dashboard.capo_imputazione_legge"></select>
              </div>
              <div class="itemFiltri">
                <label for="">Importo evaso</label>
                <div class="slider-cont">
                  <MinMaxSlider ref="minMaxSlider_importo_evaso"
                                v-model:min="model.pen_flow_dashboard.importo_evaso_min"
                                v-model:max="model.pen_flow_dashboard.importo_evaso_max"
                                :step="Model.lista_importi_minMax[2]"
                                v-model:active="model.pen_flow_dashboard.importo_evaso_active"
                                v-model:min-value="model.pen_flow_dashboard.importo_evaso_da"
                                v-model:max-value="model.pen_flow_dashboard.importo_evaso_a"
                                :cid="'importo_evaso'"
                                :changeFunct="fromMinMaxSlider" :section="'penale'"
                  />
                  <div class="legenda">
                    <span v-html="model.pen_flow_dashboard.importo_evaso_active? '[A] ':'[N] '"></span>
                    <span
                        v-html="Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(model.pen_flow_dashboard.importo_evaso_da)"></span>
                    &nbsp; <i class="bi bi-arrows"></i> &nbsp;
                    <span
                        v-html="Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(model.pen_flow_dashboard.importo_evaso_a)"></span>
                  </div>
                </div>
              </div>
              <div class="itemFiltri">
                <label for="">Anno</label>
                <div class="slider-cont">
                  <MinMaxSlider ref="minMaxSlider_data_pronuncia_sentenza"
                                v-model:active="model.pen_flow_dashboard.data_pronuncia_sentenza_active"
                                v-model:min="model.pen_flow_dashboard.data_pronuncia_sentenza_min"
                                v-model:max="model.pen_flow_dashboard.data_pronuncia_sentenza_max"
                                :step="1"
                                v-model:min-value="model.pen_flow_dashboard.data_pronuncia_sentenza_da"
                                v-model:max-value="model.pen_flow_dashboard.data_pronuncia_sentenza_a"
                                :cid="'data_pronuncia_sentenza'"
                                :changeFunct="fromMinMaxSlider" :section="'penale'"
                  />
                  <div class="legenda">
                    <span v-html="model.pen_flow_dashboard.data_pronuncia_sentenza_active? '[A] ':'[N] '"></span>
                    <span v-html="model.pen_flow_dashboard.data_pronuncia_sentenza_da"></span>
                    &nbsp; <i class="bi bi-arrows"></i> &nbsp;
                    <span v-html="model.pen_flow_dashboard.data_pronuncia_sentenza_a"></span></div>
                </div>
              </div>
              <div class="itemFiltri">
                <label for="input_id_localita">Città</label>
                <select class="form-select js-choice" id="input_id_localita"
                        v-model="model.pen_flow_dashboard.id_localita"
                        @change="changeDashboardAt('id_localita')">
                </select>
              </div>
              <div class="itemFiltri">
                <label for="input_giudice">Giudice</label>
                <select class="form-select js-choice" id="input_giudice" v-model="model.pen_flow_dashboard.giudice"
                        @change="changeDashboardAt('giudice')">
                </select>
              </div>


            <!-- ALTRIFILTRI -->
            <hr class="my-3">

              <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-0 mb-1 text-body-secondary text-uppercase cursor-pointer"
                  data-bs-target="#collapseAltriFiltri"
                  data-bs-toggle="collapse">
                <span>Altri filtri</span>
                <span>
                  <i class="bi bi-arrows-collapse"></i>
                </span>
              </h6>
              <div class="collapse show" id="collapseAltriFiltri">
                <hr class="my-3">
                <div class="itemFiltri">
                  <label for="input_assoluzione">Esito del giudizio</label>
                  <select class="form-select" id="input_assoluzione" v-model="model.pen_flow_dashboard.assoluzione"
                          @change="changeDashboardAt('assoluzione')">
                    <option value="">Scegli...</option>
                    <option v-for="(item, index) in Model.lista_esito_del_processo" :value="item" :key="'esito_'+item">{{ Model.lista_esito_del_processo_labels[index] }}</option>
                  </select>
                </div>
                <div class="itemFiltri">
                  <label for="input_assoluzione_motivo">Motivo assoluzione</label>
                  <select class="form-select js-choice" id="input_assoluzione_motivo"
                          v-model="model.pen_flow_dashboard.assoluzione_motivo"
                          @change="changeDashboardAt('assoluzione_motivo')">
                  </select>
                </div>
                <div class="itemFiltri">
                  <label for="input_pena_principale">Pena principale</label>
                  <select class="form-select js-choice" id="input_pena_principale"
                          v-model="model.pen_flow_dashboard.pena_principale"
                          @change="changeDashboardAt('pena_principale')">
                  </select>
                </div>
                <div class="itemFiltri">
                  <label for="">Durata processo</label>
                  <div class="slider-cont">
                    <input @input="disableActive('durata_del_processo')" type="range" class="form-range range_input"
                           min="0" max="10000" step="1" id="input_durata_del_processo"
                           v-model="model.pen_flow_dashboard.durata_del_processo"/>
                    <span class="range_value"> <input @input="disableActive('durata_del_processo')" type="number"
                                                      class="form-range" min="0" max="10000" step="1"
                                                      id="input_durata_del_processo2"
                                                      v-model="model.pen_flow_dashboard.durata_del_processo"/></span>
                    <div class="form-check form-switch">
                      <button @click="manageActive('durata_del_processo')" class="btn btn-sm btn-primary btn-for-slider"
                              v-if="!model.pen_flow_dashboard.durata_del_processo_active">Applica
                      </button>
                      <button @click="manageActive('durata_del_processo')" class="btn btn-sm btn-danger btn-for-slider"
                              v-else>Rimuovi
                      </button>
                    </div>
                  </div>
                </div>
                <div class="itemFiltri">
                  <label for="">Durata della pena</label>
                  <div class="slider-cont">
                    <input @input="disableActive('durata_pena')" type="range" class="form-range range_input" min="0"
                           max="10000" step="1" id="input_durata_pena" v-model="model.pen_flow_dashboard.durata_pena"/>
                    <span class="range_value"> <input @input="disableActive('durata_pena')" type="number"
                                                      class="form-range" min="0" max="10000" step="1"
                                                      id="input_durata_pena"
                                                      v-model="model.pen_flow_dashboard.durata_pena"/></span>
                    <div class="form-check form-switch">
                      <button @click="manageActive('durata_pena')" class="btn btn-sm btn-primary btn-for-slider"
                              v-if="!model.pen_flow_dashboard.durata_pena_active">Applica
                      </button>
                      <button @click="manageActive('durata_pena')" class="btn btn-sm btn-danger btn-for-slider" v-else>
                        Rimuovi
                      </button>
                    </div>
                  </div>
                </div>
                <div class="itemFiltri">
                  <label for="">Importo risarcimento</label>
                  <div class="slider-cont">
                    <MinMaxSlider ref="minMaxSlider_importo_risarcimento"
                                  v-model:active="model.pen_flow_dashboard.importo_risarcimento_active"
                                  v-model:min="model.pen_flow_dashboard.importo_risarcimento_min"
                                  v-model:max="model.pen_flow_dashboard.importo_risarcimento_max"
                                  :step="Model.lista_importi_minMax[2]"
                                  v-model:min-value="model.pen_flow_dashboard.importo_risarcimento_da"
                                  v-model:max-value="model.pen_flow_dashboard.importo_risarcimento_a"
                                  :cid="'importo_risarcimento'"
                                  :changeFunct="fromMinMaxSlider" :section="'penale'"
                    />
                    <div class="legenda">
                      <span v-html="model.pen_flow_dashboard.importo_risarcimento_active? '[A] ':'[N] '"></span>
                      <span
                          v-html="Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(model.pen_flow_dashboard.importo_risarcimento_da)"></span>
                      &nbsp; <i class="bi bi-arrows"></i> &nbsp;
                      <span
                          v-html="Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(model.pen_flow_dashboard.importo_risarcimento_a)"></span>
                    </div>
                  </div>
                </div>
                <div class="itemFiltri">
                  <div class="form-check2 form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="input_non_menzione_nel_casellario"
                           v-model="model.pen_flow_dashboard.non_menzione_nel_casellario"
                           @change="changeDashboardAt('non_menzione_nel_casellario')">
                    &nbsp;<label class="form-check-label" for="input_non_menzione_nel_casellario">Non menzione
                    casellario</label><br>
                  </div>
                </div>
              </div>

            <hr class="my-3">
          </div>
        </div>
      </div>

      <!-- COLONNA DX -->
      <main id="colonnaDX" class="col-md-9 ms-sm-auto col-lg-10 px-md-4 mb-4 pt-1 colonnaDxPenale">
        <button id="toggleColonnaSX" class="btn" @click="toggleSidebar()" title="Mostra/Nascondi Filtri"><i
            class="bi bi-list"></i></button>
        <!-- GRAFICI -->
        <div class="row">
          <div class="col-4 p-2">
            <div class="itemBox">
              <!-- button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      data-bs-title="<em>Info</em> sulla label <b>attuale</b>">
                <i class="bi bi-info-circle-fill"></i>
              </button -->
              <h4>Numero sentenze prese in esame</h4>
              <h5 v-html="model.pen_get_dashboard.totale_numero_sentenze.valore"></h5>
              <h6 v-if="model.pen_get_dashboard.totale_numero_sentenze?.valore > 0"> <!-- Lorem ipsum --></h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
            </div>
          </div>
          <div class="col-4 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_durata_del_processo"
                      data-bs-title="Questo dato ti permette di filtrare i processi in base alla loro durata media. <br>Clicca qui se vuoi filtrare le sentenze ottenendo solo quelle per cui è possibile risalire alla durata complessiva del procedimento.">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4 class="clickableBox" @click="clickOnBox('durata_del_processo', model.pen_get_dashboard.durata_del_processo.valore)">Durata processo</h4>
              <h5 v-html="model.pen_get_dashboard.durata_del_processo.valore" class="clickableBox" @click="clickOnBox('durata_del_processo', model.pen_get_dashboard.durata_del_processo.valore)"></h5>
              <h6 v-if="model.pen_get_dashboard.durata_del_processo?.valore > 0">Il 50% dei processi ha una durata in
                mesi superiore</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
            </div>
          </div>
          <div class="col-4 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_durata_condanna"
                      data-bs-title="Questo dato ti permette di filtrare i processi in base alla durata media delle condanne inflitte.<br> Il filtro è attivo solo sulle sentenze in cui vi è almeno una condanna. ">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4 class="clickableBox" @click="clickOnBox('durata_condanna', model.pen_get_dashboard.durata_condanna.valore)">Durata condanna</h4>
              <h5 v-html="model.pen_get_dashboard.durata_condanna.valore" class="clickableBox" @click="clickOnBox('durata_condanna', model.pen_get_dashboard.durata_condanna.valore)"></h5>
              <h6 v-if="model.pen_get_dashboard.durata_condanna?.valore > 0">Il 50% delle pene ha una durata in giorni
                superiore</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
            </div>
          </div>

          <div class="col-4 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_esito_del_processo"
                      data-bs-title="Questo grafico ti permette di scegliere tra le sentenze in cui tutti gli imputati sono stati assolti oppure tra quelle in cui tutti gli imputati sono stati condannati.<br>
Le sentenze miste presentano imputati in parte assolti e in parte condannati, oppure più capi di imputazioni per cui un imputato è stato in parte assolto e in parte condannato.<br>
Scegli il filtro di tuo interesse.
">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4>Esito del giudizio</h4>
              <h6 v-if="model.pen_get_dashboard.esito_del_processo?.length > 0"><!-- Lorem ipsum --></h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
              <canvas id="canvas_assoluzione"></canvas>
            </div>
          </div>
          <div class="col-8 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_esito_del_processo_per_anno"
                      data-bs-title="Questo grafico ti permette di analizzare gli esiti dei processi in base alla data di pronuncia della sentenza per annate degli esiti dei processi oggetto di analisi.<br>
Puoi selezionare l’esito del procedimento oppure un anno in particolare.<br>
Scegli il filtro di tuo interesse.">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4>Esito del processo per annata</h4>
              <h6 v-if="model.pen_get_dashboard.esito_del_processo_per_anno?.length > 0">Esito sentenza per anno</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
              <canvas id="canvas_esito_del_processo_per_anno"></canvas>
            </div>
          </div>

          <div class="col-4 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_importo_evaso"
                      data-bs-title="Viene qui riportato il valore medio degli importi evasi o non corrisposti nei processi oggetto di analisi.<br> Clicca su questo dato se vuoi vedere le sole sentenze che riportano questi valori. ">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4 class="clickableBox" @click="clickOnBox('importo_evaso', model.pen_get_dashboard.importo_evaso.valore)">Importi evasi o non corrisposti</h4>
              <h5 v-html="Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(model.pen_get_dashboard.importo_evaso.valore)" class="clickableBox" @click="clickOnBox('importo_evaso', model.pen_get_dashboard.importo_evaso.valore)"></h5>
              <h6 v-if="model.pen_get_dashboard.importo_evaso?.valore > 0">Il 50% degli importi ha un valore superiore a
                questa cifra</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
            </div>
          </div>
          <div class="col-4 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_importo_risarcimento"
                      data-bs-title="Viene qui riportato il valore medio degli importi risarciti dai condannati.<br> Clicca su questo dato se vuoi vedere le sole sentenze che riportano questi valori.">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4 class="clickableBox" @click="clickOnBox('importo_risarcimento', model.pen_get_dashboard.importo_risarcimento.valore)">Importi risarciti in caso di condanna</h4>
              <h5 v-html="Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(model.pen_get_dashboard.importo_risarcimento.valore)" class="clickableBox" @click="clickOnBox('importo_risarcimento', model.pen_get_dashboard.importo_risarcimento.valore)"></h5>
              <h6 v-if="model.pen_get_dashboard.importo_risarcimento?.valore > 0">Il 50% degli importi risarciti ha un
                valore superiore a questa cifra</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
            </div>
          </div>
          <div class="col-4 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      data-bs-title="Sentenze in cui si dà atto della <b>non menzione</b> nel casellario giudiziale">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4 class="clickableBox" @click="clickOnBox('non_menzione_nel_casellario', model.pen_get_dashboard.non_menzione_nel_casellario.valore)">Casellario giudiziale</h4>
              <h5 v-html="model.pen_get_dashboard.non_menzione_nel_casellario.valore" class="clickableBox" @click="clickOnBox('non_menzione_nel_casellario', model.pen_get_dashboard.non_menzione_nel_casellario.valore)"></h5>
              <h6 v-if="model.pen_get_dashboard.non_menzione_nel_casellario?.valore > -1">Sentenze che prevedono la non
                menzione nel casellario giudiziale</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
            </div>
          </div>


          <div class="col-6 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_distribuzione_delle_sanzioni"
                      data-bs-title="Questo grafico ti permette di scegliere tra le diverse tipologie di pena principale previste dal nostro ordinamento e si applica alle sole sentenze in cui vi è stata almeno una condanna.<br>
Scegli il filtro di tuo interesse.
">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4>Distribuzione delle sanzioni</h4>
              <h6 v-if="model.pen_get_dashboard.distribuzione_delle_sanzioni?.length > 0"><!-- Lorem ipsum --></h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
              <canvas id="canvas_distribuzione_delle_sanzioni"></canvas>
            </div>
          </div>
          <div class="col-6 p-2">
            <div class="itemBox">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_distribuzione_motivi_assoluzione"
                      data-bs-title="Questo grafico ti permette di scegliere tra le diverse tipologie di motivazioni che hanno portato all’assoluzione dell’imputato ed è attivo sulle sole sentenze in cui vi è stata almeno una assoluzione.<br>
Scegli il filtro di tuo interesse.
">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4>Distribuzione motivi di assoluzione</h4>
              <h6 v-if="model.pen_get_dashboard.distribuzione_motivi_assoluzione?.length > 0"><!-- Lorem ipsum --></h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
              <canvas id="canvas_distribuzione_motivi_assoluzione"></canvas>
            </div>
          </div>

          <div class="col-6 p-2">
            <div class="itemBox itemBoxDouble">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_durata_del_processo_per_singola_citta"
                      data-bs-title="Questo grafico ti permette di verificare la durata di un processo in base al luogo in cui si è svolto.<br> Clicca sulla singola città per avere l’indicazione diretta dell’andamento in quel foro.<br>
Scegli il filtro di tuo interesse.">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4>Durata del processo per singola città</h4>
              <h6 v-if="model.pen_get_dashboard.durata_del_processo_per_singola_citta?.length > 0">Il 50% dei processi
                ha avuto una durata in mesi superiore al valore indicato</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
              <canvas id="canvas_durata_del_processo_per_singola_citta"></canvas>
            </div>

            <div class="itemBox itemBoxDouble">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      id="tooltip_esito_del_processo_per_citta"
                      data-bs-title="Il grafico riporta la distribuzione per città degli esiti dei processi oggetto di analisi.<br>Clicca sulla tipologia di esito del processo per avere l’indicazione specifica rispetto al singolo foro.<br>
Scegli il filtro di tuo interesse.
">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4>Esito del processo per città</h4>
              <h6 v-if="model.pen_get_dashboard.esito_del_processo_per_citta?.length > 0">Distribuzione stato
                assoluzione</h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
              <canvas id="canvas_esito_del_processo_per_citta"></canvas>
            </div>
          </div>
          <div class="col-6 p-2">
            <div class="itemBox itemBoxMap">
              <button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      data-bs-title="Clicca sulla singola città per applicare il relativo filtro">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h4>Mappa</h4>
              <h6 v-if="model.pen_get_dashboard.totale_sentenze_per_tribunale?.length > 0"><!-- Lorem ipsum --></h6>
              <h6 v-else>Dato non disponibile con i filtri attuali.</h6>
              <div id="map">

              </div>
            </div>
          </div>

          <div class="col-12 p-2">
            <div class="itemBox itemBoxLast">
              <!-- button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true"
                      data-bs-title="<em>Info</em> sulla label <b>attuale</b>">
                <i class="bi bi-info-circle-fill"></i>
              </button -->
              <h4>Sentenze</h4>

              <div class="table-responsive small table-documenti" v-if="model.pen_get_dashboard.sentenze_paginate && model.pen_get_dashboard.sentenze_paginate.length && model.pen_get_dashboard.sentenze_paginate.length > 0">
                <table class="table table-striped table-sm">
                  <!-- thead>
                  <tr>
                    <th scope="col">Estremi</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                  </thead -->
                  <tbody>
                  <template v-for="(item, index) in model.pen_get_dashboard.sentenze_paginate">
                    <tr v-if="item.estremi" :id="'docRiga-penale-dashboard-'+index">
                      <!-- td><em>{{ (new Date(item.date)).toLocaleDateString() }}</em></td -->
                      <td>{{item.estremi}}</td>
                      <td class="text-right">
                        <a href="javascript:void(0)" @click="sintetizzaConAi(item.estremi as string, item.id_doc_master as number, index)" v-if="item.tipologia_doc != 136">
                          <i class="bi bi-stars"></i> Sintetizza con AI
                        </a>
                        <span v-else> </span>
                      </td>
                      <td class="text-right">
                        <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                          <i class="bi bi-link"></i> Apri dettaglio
                        </a>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>

              <div class="row" v-if="model.pen_get_dashboard.sentenze_paginate && model.pen_get_dashboard.sentenze_paginate.length && model.pen_get_dashboard.sentenze_paginate.length > 0">
                <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">
                  <button class="btn btn-sm btn-primary" @click="apriDettaglio()" v-if="model.abbonatoDejure"><i class="bi bi-box-arrow-up-right" v-if="!model.openingDejure"></i> <div v-else class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>&nbsp;  Approfondisci su DeJure</button>
                  <button class="btn btn-sm btn-error" @click="generaReport()" v-if="model.pen_flow_dashboard.assoluzione != ''">
                    <i class="bi bi-download" v-if="!model.generatingPdf"></i>
                    <div v-else class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    &nbsp; Genera report
                  </button>
                </div>
                <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
                  <b>{{ model.pen_flow_dashboard.paginazione_tot }}</b> Elementi Totali |
                  Pagina <b>{{ (model.pen_flow_dashboard.paginazione_start + 1) }}</b> di
                  <b>{{ (model.pen_flow_dashboard.paginazione_pages + 1) }}</b>
                </div>
                <div class="col-12 col-sm-12 col-xl-5">
                  <PaginazioneDashboard ref="paginazione_component" @recalc="callQueryPaginazione()"></PaginazioneDashboard>
                </div>


                <!-- principi di diritto -->
                <div class="col-12 mt-3" v-if="model.abbonatoDejure && model.pen_get_dashboard.sentenze_paginate_jump_display && model.pen_get_dashboard.sentenze_paginate_jump_display.length && model.pen_get_dashboard.sentenze_paginate_jump_display.length > 0">
                  <h4>Principi di diritto </h4>

                  <div class="table-responsive small table-documenti">
                    <table class="table table-striped table-sm">
                      <tbody>
                      <template v-for="(item, index) in model.pen_get_dashboard.sentenze_paginate_jump_display">
                        <tr v-if="item.estremi || item.id_doc_master" :id="'docRiga-penale-dashboard-jump-'+index">
                          <td v-if="item.estremi">{{item.estremi}}</td>
                          <td v-else> {{item.id_doc_master}}</td>
                          <td class="text-right">
                            <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                              <i class="bi bi-link"></i> Apri dettaglio
                            </a>
                          </td>
                        </tr>
                      </template>
                      </tbody>
                    </table>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">

                    </div>
                    <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
                      <b>{{ model.pen_flow_dashboard.diritto_paginazione_tot }}</b> Elementi Totali |
                      Pagina <b>{{ (model.pen_flow_dashboard.diritto_paginazione_start + 1) }}</b> di
                      <b>{{ (model.pen_flow_dashboard.diritto_paginazione_pages + 1) }}</b>
                    </div>
                    <div class="col-12 col-sm-12 col-xl-5">
                      <PaginazioneDashboardJump ref="paginazione_jump_component"></PaginazioneDashboardJump>
                    </div>
                  </div>

                </div>

              </div>
              <div class="row" v-else>
                <div class="col-12">
                  Non sono presenti sentenze
                </div>
              </div>


            </div>
          </div>

        </div>
      </main>
    </div>
  </div>
</template>